const SEARCH = "http://www.google.com/search?q=";
const SEARCH_STRING =
  ".com -inurl:(followers|type|members|following|jobs|designers|players|buckets|places|skills|projects|tags|search|stories|users|draftees|likes|lists) -intitle:(following|likes) -'Hire Us'";
export { SEARCH, SEARCH_STRING };
